// FeedSliceSchema.ts

import { z } from "zod";
import { FeedItemSchema } from "@bridge-applications/eh-types";

/**
 * Client-only extension for each feed item.
 * Use the shared union from `eh-types` and intersect our local fields.
 */
export const ExtendedFeedItemSchema = FeedItemSchema.and(
    z.object({
        spotsLeft: z.number().nullable().optional(),
    }),
);

export const FeedSliceSchema = z.object({
    items: z.array(ExtendedFeedItemSchema),
    returnedItemCount: z.number(),
    totalItemCount: z.number(),
    nextCursor: z.string().nullable(),
});
